import React, { ReactElement } from 'react';

export function Nothing(): ReactElement {
  return <></>;
}
